<div class="modal-header">
  <h5 class="modal-title"><i class="fal fa-cloud-upload"></i> Upload Files</h5>
  <button (click)="close.emit()" type="button" class="close">
    <i class="fas fa-times"></i>
  </button>
</div>
<div class="modal-body">
  <div ng2FileDrop [uploader]="uploader" class="upload-box">
    <input type="file" #fileInput ng2FileSelect [uploader]="uploader" multiple class="d-none" />
    <h5>
      Drop files here or <a href="javascript:;" (click)="fileInput.click()" class="upload-button">click</a> to upload
    </h5>
    <p class="upload-guide" [innerHTML]="getGuideText()"></p>
  </div>
  <div class="table-responsive" *ngIf="files.length">
    <table class="table table-condensed" aria-hidden="false">
      <thead>
        <tr>
          <th>Name</th>
          <th>Size</th>
          <th>Progress</th>
          <th>Delete</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let file of files; let i = index">
          <td>{{ file.file.name }}</td>
          <td>{{ file.file.size | fileSize }}</td>
          <td>
            <mat-progress-bar mode="determinate" [value]="file.progress"></mat-progress-bar>
          </td>
          <td>
            <a (click)="onRemoveFile(file, i)" class="td-btn text-danger">
              <i class="fal fa-trash-alt"></i>
            </a>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
<div class="modal-footer">
  <button (click)="switchToRecentFiles.emit()" type="button" class="btn btn-success text-uppercase create-btn">
    <i class="fal fa-list-ul"></i> Select
  </button>
</div>
